const initialState = () => ({
  paginate_companies: [], // empresas paginadas
  pagination_companies: { total: 0, page: 0 }, // paginación de empresas
  simple_companies: [], // empresas con datos simples
})

export default initialState
